class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.initTabSwitcher();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  initTabSwitcher() {
    const megaMenuLinks = this.querySelectorAll('.mega-menu__link--level-2');
    const imageCardWrappers = this.querySelectorAll('.mega-menu__image-card');
    let selectedSection = null;

    if (!megaMenuLinks.length || !imageCardWrappers.length) return;

    const showTab = (sectionClass) => {
      imageCardWrappers.forEach(wrapper => {
        const card = wrapper.querySelector('.mega-menu_image-card-tabswitcher');
        if (card && card.getAttribute('data-tag') === sectionClass) {
          wrapper.classList.add('active');
        } else {
          wrapper.classList.remove('active');
        }
      });
    };

    const filterMenuItems = (sectionClass) => {
      megaMenuLinks.forEach(link => {
        const linkHTML = link.innerHTML;
        const classMatch = linkHTML.match(/class=["']([^"']+)["']/);
        const linkParent = link.closest('li');

        if (!linkParent) return;

        if (classMatch && classMatch[1] === sectionClass) {
          // Show matching menu items
          linkParent.style.display = '';
        } else {
          // Hide non-matching menu items
          linkParent.style.display = 'none';
        }
      });
    };

    // Set initial state - activate first tab by default
    if (imageCardWrappers.length > 0) {
      const firstCard = imageCardWrappers[0].querySelector('.mega-menu_image-card-tabswitcher');
      if (firstCard) {
        const firstDataTag = firstCard.getAttribute('data-tag');
        selectedSection = firstDataTag;
        showTab(firstDataTag);
        filterMenuItems(firstDataTag);
        imageCardWrappers[0].classList.add('selected');
      }
    }

    // Add click event listeners to image cards for filtering
    imageCardWrappers.forEach(wrapper => {
      const card = wrapper.querySelector('.mega-menu_image-card-tabswitcher');
      if (!card) return;

      card.style.cursor = 'pointer';

      card.addEventListener('click', () => {
        const dataTag = card.getAttribute('data-tag');

        // Don't do anything if clicking the already selected tab
        if (selectedSection === dataTag) return;

        // Switch to new section - filter menu items
        selectedSection = dataTag;
        filterMenuItems(dataTag);
        showTab(dataTag);

        // Update selected state on image cards
        imageCardWrappers.forEach(w => w.classList.remove('selected'));
        wrapper.classList.add('selected');
      });
    });

    // Add hover/focus event listeners to menu links for tab switching
    megaMenuLinks.forEach(link => {
      const handleInteraction = () => {
        // Extract class name from menu title HTML
        // Look for <div class="section-name"> or other elements with class
        const linkHTML = link.innerHTML;
        const classMatch = linkHTML.match(/class=["']([^"']+)["']/);

        if (classMatch) {
          const className = classMatch[1];

          // Check if we have an image for this section class
          const hasMatchingImage = Array.from(imageCardWrappers).some(wrapper => {
            const card = wrapper.querySelector('.mega-menu_image-card-tabswitcher');
            return card && card.getAttribute('data-tag') === className;
          });

          if (hasMatchingImage) {
            showTab(className);
          }
        }
      };

      link.addEventListener('mouseenter', handleInteraction);
      link.addEventListener('focus', handleInteraction);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
